import axiosInstance from '../../api/axiosInstance'
import { EnviaComResponse } from '../../types/enviaCom'
import { buildEnviaComQuoteRequest } from '../../utils/quoteFormDataUtils'

export const cotizarConCoordinadora = async (
  formData: Record<string, unknown>,
  orderDetail: Record<string, unknown> | null
): Promise<EnviaComResponse> => {
  const token = localStorage.getItem('accessToken')
  if (!token) {
    throw new Error('Error de autenticación')
  }

  const requestData = buildEnviaComQuoteRequest(formData, orderDetail, {
    carrier: 'coordinadora',
    service: 'ecommerce',
    type: 1
  })

  try {
    console.log('📤 Enviando cotización a Coordinadora:', requestData)
    const response = await axiosInstance.post('/envia-com/quote', requestData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
    console.log('✅ Respuesta de Coordinadora:', response.data)
    return response.data
  } catch (error: unknown) {
    console.error('❌ Error en cotización Coordinadora:', error)
    const err = error as { response?: { status: number; data?: { message?: string; error?: string } }; request?: unknown; message?: string }
    if (err.response) {
      const { status, data } = err.response
      throw new Error(`Coordinadora API Error (${status}): ${data?.message || data?.error || 'Error desconocido'}`)
    }
    if (err.request) {
      throw new Error('Coordinadora API: No se pudo conectar con el servidor')
    }
    throw new Error(`Coordinadora API: ${err.message || 'Error desconocido'}`)
  }
}
